import {
  computeStartRangeRectBounds,
  findOffsetKeysLeaves,
  findSelectionBoundsWithinLeaves,
  hasEntityAtSelection,
} from "./utils";

import { Component } from "react";
import MentionSpanOffsetTracker from "./MentionSpanOffsetTracker";
import PropTypes from "prop-types";

export default class MentionTypeaheadState extends Component {
  static propTypes = {
    queryUntilCursor: PropTypes.bool,
    editorState: PropTypes.object.isRequired,
    children: PropTypes.func.isRequired,
  };

  static defaultProps = {
    queryUntilCursor: false,
  };

  state = {
    top: -9999,
    left: -9999,
    visible: false,
    mentionQuery: "",
  };

  componentWillReceiveProps({ editorState }) {
    this.setState(null, () => {
      this.calculateAndSetState(editorState);
    });
  }

  calculateAndSetState = editorState => {
    const currentSelection = editorState.getSelection();
    const originalContent = editorState.getCurrentContent();

    if (currentSelection.isCollapsed() === false || currentSelection.getHasFocus() === false) {
      this.resetState();
      return;
    }

    if (hasEntityAtSelection(editorState, currentSelection)) {
      this.resetState();
      return;
    }

    const foundBounds = findSelectionBoundsWithinLeaves(
      currentSelection,
      findOffsetKeysLeaves(editorState, MentionSpanOffsetTracker.getOffsetKeys()),
    );

    if (foundBounds === null) {
      this.resetState();
      return;
    }

    const anchorKey = currentSelection.getAnchorKey();
    const currentBlock = originalContent.getBlockForKey(anchorKey);
    const plainString = currentBlock.getText();

    let mentionQuery;
    const { queryUntilCursor } = this.props;

    if (queryUntilCursor) {
      mentionQuery = plainString.substring(
        foundBounds.start,
        Math.min(foundBounds.end, currentSelection.getAnchorOffset()),
      );
    } else {
      mentionQuery = plainString.substring(foundBounds.start, foundBounds.end);
    }

    const lastAtIndex = mentionQuery.lastIndexOf("@");

    const activeSelectionRect = computeStartRangeRectBounds(window, lastAtIndex);

    if (activeSelectionRect === null) {
      this.resetState();
      return;
    }

    this.setState({
      top: activeSelectionRect.top,
      left: activeSelectionRect.left,
      mentionQuery: mentionQuery.substring(lastAtIndex, mentionQuery.length),
      visible: true,
    });
  };

  resetState = () =>
    this.setState({
      top: -9999,
      left: -9999,
      visible: false,
      mentionQuery: "",
    });

  render() {
    const { children } = this.props;
    const { top, left, visible, mentionQuery } = this.state;

    return children({
      top,
      left,
      visible,
      mentionQuery,
      resetState: this.resetState,
    });
  }
}
